/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_section_4_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We use cookies and similar tracking technologies to collect and store information about your interactions with our service:`)
};

const es_privacy_section_4_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usamos cookies y tecnologías de rastreo similares para recopilar y almacenar información sobre tus interacciones con nuestro servicio:`)
};

const de_privacy_section_4_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir verwenden Cookies und ähnliche Tracking-Technologien, um Informationen über Ihre Interaktionen mit unserem Dienst zu erfassen und zu speichern:`)
};

const nl_privacy_section_4_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We gebruiken cookies en vergelijkbare trackingtechnologieën om informatie over uw interacties met onze dienst te verzamelen en op te slaan:`)
};

const fr_privacy_section_4_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous utilisons des cookies et technologies de suivi similaires pour collecter et stocker des informations sur vos interactions avec notre service :`)
};

const it_privacy_section_4_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizziamo cookie e tecnologie di tracciamento simili per raccogliere e memorizzare informazioni sulle tue interazioni con il nostro servizio:`)
};

const pt_br2_privacy_section_4_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usamos cookies e tecnologias de rastreamento semelhantes para coletar e armazenar informações sobre suas interações com nosso serviço:`)
};

const pt_privacy_section_4_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizamos cookies e tecnologias de rastreamento semelhantes para recolher e armazenar informação sobre as suas interações com o nosso serviço:`)
};

const ja_privacy_section_4_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当サービスとのやり取りに関する情報を収集・保存するために、Cookieおよび類似のトラッキング技術を使用しています:`)
};

const zh_privacy_section_4_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们使用Cookie和类似跟踪技术来收集和存储您与我们服务互动的信息：`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_section_4_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_section_4_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_section_4_intro", locale)
	if (locale === "en") return en_privacy_section_4_intro(inputs)
	if (locale === "es") return es_privacy_section_4_intro(inputs)
	if (locale === "de") return de_privacy_section_4_intro(inputs)
	if (locale === "nl") return nl_privacy_section_4_intro(inputs)
	if (locale === "fr") return fr_privacy_section_4_intro(inputs)
	if (locale === "it") return it_privacy_section_4_intro(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_section_4_intro(inputs)
	if (locale === "pt") return pt_privacy_section_4_intro(inputs)
	if (locale === "ja") return ja_privacy_section_4_intro(inputs)
	return zh_privacy_section_4_intro(inputs)
};